// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1YteQ","file":"styles_file__2d6GL"};